import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { UserStateProvider } from './context/UserContext/UserContext';
import { createRoot } from 'react-dom/client';
import ConfigStateProvider from './context/ConfigStateContext';
import { PrimeReactProvider } from 'primereact/api';
import TranslationProvider from './context/TranslationContext';
import ForceErrorModalContextProvider from './context/ForceErrorModalContext';
import EntryErrorModalContextProvider from './context/EntryErrorModalContext/EntryErrorModalContext';
import AppToaster from './components/AppToaster/AppToaster';
const queryClient = new QueryClient();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA

// Disabled mock browser on dev environment to get real api requests

// if (process.env.NODE_ENV === 'development') {
//   const { worker } = require('./api/mocks/browser');
//   worker.start({
//     onUnhandledRequest: 'bypass',
//     quiet: true,
//   });
//   serviceWorkerRegistration.unregister();
// } else {
//   serviceWorkerRegistration.unregister();
// }
serviceWorkerRegistration.unregister();

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <QueryClientProvider client={queryClient}>
    <ConfigStateProvider>
      <UserStateProvider>
        <TranslationProvider>
          <AppToaster />
          <ForceErrorModalContextProvider>
            <EntryErrorModalContextProvider>
              <PrimeReactProvider>
                <App />
              </PrimeReactProvider>
            </EntryErrorModalContextProvider>
          </ForceErrorModalContextProvider>
        </TranslationProvider>
      </UserStateProvider>
    </ConfigStateProvider>
  </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
